import JoinButton from './JoinButton';

export default JoinButton;
